var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultDateConfig } from '@juvare/common-web-ui/utils';
import { getDataValue, removeDataValue } from '@juvare/json-data-util';
import { format } from 'date-fns/format';
import { parseISO } from 'date-fns/parseISO';
import React from 'react';
import { QuickFilterDatePicker } from '../components';
export function quickFilterDatePicker(params) {
    return {
        quickFilter: {
            render: (props) => (React.createElement(QuickFilterDatePicker, Object.assign({}, props, { dataPath: params.dataPath, label: params.label, "data-test": params.dataTest }))),
            dataPath: params.dataPath,
        },
        widgetConfig: {
            type: 'form.datePicker',
            key: params.dataPath,
            label: params.label,
        },
        getFilterChips: (filterData) => __awaiter(this, void 0, void 0, function* () {
            const data = getDataValue(filterData, params.dataPath);
            if (data === null || data === void 0 ? void 0 : data.date) {
                return [
                    {
                        label: format(parseISO(data.date), defaultDateConfig.dateFormat),
                        onRemoveChip: (chipFilterData) => handleRemoveChip(chipFilterData, params.dataPath),
                        groupId: params.dataPath,
                    },
                ];
            }
            else if (data && typeof data === 'string') {
                return [
                    {
                        label: format(parseISO(data), defaultDateConfig.dateFormat),
                        onRemoveChip: (chipFilterData) => handleRemoveChip(chipFilterData, params.dataPath),
                        groupId: params.dataPath,
                    },
                ];
            }
            else {
                return [];
            }
        }),
    };
}
function handleRemoveChip(filterData, dataPath) {
    const newFilterData = JSON.parse(JSON.stringify(filterData));
    removeDataValue(newFilterData, dataPath);
    return newFilterData;
}
